Ext.define('SA.data.ExpectedCounterpartAttributeFactory', {
    singleton: true,

    buildTypes() {
        var count = SA.data.CounterpartAttributeType.create({stringValue: 'count', symbol: '#'}),
            percent = SA.data.CounterpartAttributeType.create({stringValue: 'percent', symbol: '%'});

        count.setCounterpart(percent);
        percent.setCounterpart(count);

        this.types = [count, percent];
    },

    create({attribute: basisAttribute}) {
        if (!this.isMatchableAttribute(basisAttribute)) {
            return null;
        }

        var counterpartType = this.getTypeForString(basisAttribute.type).counterpart();

        return SA.data.ExpectedCounterpartAttribute.create({
            type: counterpartType.stringValue(),
            name: counterpartType.symbol() + basisAttribute.name.slice(1),
            group: basisAttribute.group,
            country: basisAttribute.country,
            censusRelease: basisAttribute.censusRelease,
            year: basisAttribute.year
        });
    },

    getTypeForString(typeString) {
        return this.types.find(type => type.hasStringValue(typeString)) ?? null;
    },

    isMatchableAttribute(attribute) {
        var nameSymbolMatchesType = this.getTypeForString(attribute.type)?.hasSymbol(attribute.name[0]),
            isUserAttribute = SA.data.AttributesCache.isUserAttribute(attribute.attribute);

        return nameSymbolMatchesType && !isUserAttribute;
    }
}, cls => cls.buildTypes());